var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuPostsCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Hand-Held--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Hand Held Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand-held--tablet-kindle-device-electronics-ipad-computer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M2.49744 1.74746c0 -0.11322 0.09178 -0.20501 0.205 -0.20501h8.59506c0.1132 0 0.205 0.09179 0.205 0.20501V10.474H2.49744V1.74746Zm0.205 -1.70501c-0.94165 0 -1.705003 0.763358 -1.705003 1.70501V12.2525c0 0.9417 0.763353 1.7051 1.705003 1.7051h8.59506c0.9417 0 1.705 -0.7634 1.705 -1.7051V1.74746c0 -0.941652 -0.7633 -1.70501 -1.705 -1.70501H2.70244Zm1.91005 2.59323c-0.41422 0 -0.75 0.33579 -0.75 0.75s0.33578 0.75 0.75 0.75h4.77504c0.41421 0 0.74997 -0.33579 0.74997 -0.75s-0.33576 -0.75 -0.74997 -0.75H4.61249Zm-0.75 3.37421c0 -0.41422 0.33578 -0.75 0.75 -0.75h4.77504c0.41421 0 0.74997 0.33578 0.74997 0.75 0 0.41421 -0.33576 0.75 -0.74997 0.75H4.61249c-0.41422 0 -0.75 -0.33579 -0.75 -0.75Zm0.75 1.87417c-0.41422 0 -0.75 0.33579 -0.75 0.75 0 0.41422 0.33578 0.75 0.75 0.75h2.86502c0.41422 0 0.75 -0.33578 0.75 -0.75 0 -0.41421 -0.33578 -0.75 -0.75 -0.75H4.61249Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPostsCurrent);
export default __webpack_public_path__ + "static/media/menu-posts-current.f91ca97147ae15f35b6742addfc0b386.svg";
export { ForwardRef as ReactComponent };